import { Component, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { FormService } from '../../../service/FormService';
import { Restangular } from 'ngx-restangular';
import { MatDialog } from '@angular/material';
import { RestAngularConfig } from '../../../service/restAngular/rest-angular-config';
import { SuccessComponent } from './success/success.component';
import { TrackingService } from '../../../service/tracking.service';
import {DialogState, ScrollBarData} from "../scroll-bar-data";
import {AuthGuard} from "../../../service/auth-guard.service";


@Component({
  selector: 'request-quote',
  templateUrl: './request-quote.component.html',
  providers: [FormService]
})
export class RequestQuoteComponent {

  @ViewChild('quoteForm') quoteForm: NgForm;

  quote = {
    username: '',
    company: '',
    email: '',
    description: ''
  };

  constructor(private formService: FormService, private restangular: Restangular, private dialog: MatDialog,
              private trackingService: TrackingService) {
    const authToken = AuthGuard.readCookie('AuthToken') || localStorage.getItem('AuthToken');
    RestAngularConfig.RestangularProvider.setDefaultHeaders({'Authorization': 'JWT ' + authToken});
  }

  sendQuote() {
    this.formService.setTouched(this.quoteForm);
    if (!this.quoteForm.valid) return;
    this.dialog.closeAll();
    return this.restangular.all('case/').post({
      'user_name': this.quote.username,
      'email': this.quote.email,
      'company_name': this.quote.company,
      'description': this.quote.description
    }).subscribe((res) => {
      const hasScrollbar = window.innerWidth > document.documentElement.clientWidth;
      const matDialogRef = this.dialog.open(SuccessComponent);
      ScrollBarData.updateBodyWidth(DialogState.OPEN, hasScrollbar);
      matDialogRef.afterClosed().subscribe(() => ScrollBarData.updateBodyWidth(DialogState.CLOSE));
      this.trackingService.quoteRequested();
    });
  }
}



// WEBPACK FOOTER //
// /var/www/asna/front-end/public_html/src/app/components/shared/request-quote/request-quote.component.ts